<template>
    <div v-if="showPccInfo">
        <hp5-semantic size-selection="xs" v-if="showPrimaryCareClinicsOnlyButton">
            <input type="checkbox" name="primaryClinicsOnly" id="primaryClinicsOnly" value="on" v-model="filterContext.pcOnly" />
            <label for="primaryClinicsOnly">Primary care clinics only</label>
        </hp5-semantic>
        <div>
            <hp5-alert type="info" hide-alert-text inline="inline" :show-alert="true">
                <div class="pcClinic-info">
                <hp5-semantic size-selection="xs">
                    <span>Your primary care clinic is
                    <hp5-link-text-basic size="XS">
                        <a :href="clinicUrl">{{ primaryCareClinic.name }}</a> </hp5-link-text-basic>. You will receive the best coverage for primary care services when you go to this clinic.
                    </span>
                </hp5-semantic>
                </div>
            </hp5-alert>
        </div>
    </div>
</template>
<script setup lang="ts">

    const { context, filterContext, profile, plan } = useFCPModel()
    const showPrimaryCareClinicsOnlyButton = computed(
        () => (filterContext.value.type === 'medical' || filterContext.value.type === 'dental') && profile.value.isAuthenticated && isPrimaryCare.value
    )
    const isPrimaryCare = computed(() => plan.value.isPrimaryCare)
    const primaryCareClinic = computed(() => (plan.value && plan.value.primaryCareClinic ? plan.value.primaryCareClinic : null))
    const showPccInfo = computed(() => profile.value.isAuthenticated && primaryCareClinic.value)
    const isPCC = computed(() => (primaryCareClinic.value ? true : false))
    const { locationDetailUrl } = useUrls(context.value)
    const clinicUrl = computed(() => (isPCC.value ? locationDetailUrl(primaryCareClinic.value.id) : ""))

</script>

<style scoped lang="scss">
    label {
        padding-left: var(--spacing-xs);
    }
</style>